<template>
    <v-app>
        <v-dialog
            v-model="erro_dialog"
            max-width="500"
        >
            <v-card :dark="dark">
                <v-card-title class="headline">Erro!</v-card-title>
                <v-card-text>
                    Aconteceu um erro inesperado! <br>
                    {{erro_msg}}
                    Contate o suporte informando o código do erro (Cod. {{erro_id}})
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="dark ? 'white' : 'black'"
                        text
                        @click="erro_dialog = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <router-view/>
    </v-app>
</template>

<style>
html,body, .customScroll{
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
}
html::-webkit-scrollbar,body::-webkit-scrollbar,.customScroll::-webkit-scrollbar {
    width: 0px;
}
</style>

<script>
export default {
    name: 'App',
    data: () => ({
        erro_dialog: false,
        erro_id: "",
        erro_msg: "",
        dark: false,
        version: "0.4.3"
    }),
    created(){
        const googleMaps = document.createElement("script");
        const mapsKey = "AIzaSyAxpTdCfd8SxVXcjov2--j2vJlf6c7HuqE";
        googleMaps.src = `https://maps.googleapis.com/maps/api/js?key=${mapsKey}`
        googleMaps.defer = true;
        googleMaps.async = false;
        document.head.appendChild(googleMaps);

        const markerCluster = document.createElement("script");
        markerCluster.src = "https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js"
        document.head.appendChild(markerCluster);

        window.mainApp = this;

        if(localStorage.getItem("customization"))
            this.dark = JSON.parse(localStorage.getItem("customization")).dark;

        self.addEventListener('fetch', (event) => {
            event.respondWith(async function() {
                const response = await caches.match(event.request);
                return response || fetch(event.request);
            }());
        });
    }
};
</script>
